type PromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
};

const PromiseExt = Promise as typeof Promise & {
  withResolvers<T>(): PromiseWithResolvers<T>;
};

if (!PromiseExt.withResolvers) {
  // eslint-disable-next-line no-console
  console.log('[Polyfill] Adicionando PromiseExt.withResolvers');
  PromiseExt.withResolvers = function <T>() {
    let resolve: any;
    let reject: any;

    const promise = new PromiseExt<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject } as PromiseWithResolvers<T>;
  };
}

export default PromiseExt.withResolvers;
